import React, { useEffect, useContext, useState } from "react";
import { cloneDeep } from 'lodash';
import clsx from "clsx";

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Divider,
    InputLabel,
    FormControl,
    MenuItem,
    Typography,
    colors
} from "@material-ui/core";

import {
    IconPicker,
    ColorPicker,
    FieldError,
    UploadFile
} from "../../../../common";

import {
    Form,
    Formik,
    Field,
    ErrorMessage
} from "formik";

import * as Yup from 'yup';

import {
    TextField,
    CheckboxWithLabel,
    Select
} from "formik-material-ui";

import { PageContext } from "../../PageContext";
import { ToastContext } from '../../../../contexts/ToastContext';


import { ImageType, MaxFileSize, getColoredBottonStyle } from '../../../../../helpers';

import { useTranslation } from "react-i18next";

import DeleteIcon from "@material-ui/icons/Delete";
import ClearIcon from "@material-ui/icons/Clear";

import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
    root: {
    },
    title: {
        fontSize: "1.2em"
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    },
    formControl: {
        width: "100%"
    },
    progress: {
        color: "black"
    },
    pickerBox: {
        marginLeft: "-6px"
    },
    colorPicker: {
    },
    deleteButton: {
        ...getColoredBottonStyle(theme, colors.red)
    },
    deleteButton2: {
        ...getColoredBottonStyle(theme, colors.grey)
    }
}));

const fontSizeOptions = [
    { label: "Micro", value: "micro" },
    { label: "Small", value: "small" },
    { label: "Medium", value: "medium" },
    { label: "Large", value: "large" },
]

const fontStyleOptions = [
    { label: "Regular", value: "regular" },
    { label: "Bold", value: "bold" },
    { label: "Italic", value: "italic" },
]

const platformOptions = [
    { label: "iOS", value: "ios" },
    { label: "Android", value: "android" },
    { label: "iOS, Android", value: "ios, android" },
]

const BaseMenuItemSchema = Yup.object().shape({

});

export const BaseMenuItem = ({
    item,
    formRef,
    errors,
    validationSchema,
    icons,
    disableIcon,
    disableTitle,
    disableBackgroundColor,
    disableTextColor,
    disableFontSize,
    disableFontStyle,
    disablePlatform,
    disableIsVisible,
    disabled,
    upload,
    onUpdated,
    onRemove,
    onSubmit,
    ...props }) => {
    const classes = useStyles();
    const theme = useTheme();

    const { t, i18n } = useTranslation();

    const {
        state
    } = useContext(PageContext);

    const {
        showWarningMessage
    } = useContext(ToastContext);

    const {
        settings
    } = state;

    const {
        children
    } = props;

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const [bkgImage, setBkgImage] = useState(item.backgroundImage);
    const setImage = (file) => {
        setBkgImage(URL.createObjectURL(file));
    }

    const uploadfileAsync = async (data, file) => {
        if (upload) {
            const storedImageInfo = await upload(ImageType.MenuItem, data, file);
            if (storedImageInfo !== null) {
                setImage(file);
                formRef.current.setFieldValue("backgroundImage", storedImageInfo.publicUrl);
                return true;
            }
        }
        return false;
    }

    const getInitialValues = () => {
        if (item) {
            return {
                ...cloneDeep(item),
                isVisible: item.isVisible ?? false,
                isProtected: item.isProtected ?? false,
                hideIcon: item.hideIcon ?? false,
                hideTitle: item.hideTitle ?? false
            };
        } else {
            return {}
        }
    }

    const submitClickHandler = (values, actions) => {
        if (onSubmit) onSubmit(item.id, values, () => actions.setSubmitting(false));
    }

    const removeItemHandler = () => {
        setOpenDeleteDialog(false);
        if (onRemove) onRemove(item)
    }

    const fileDropHandler = (file) => {
        if (file.type.includes('image')
            && file.name.endsWith(".png")) {
            if (file.size <= MaxFileSize.Max1MB) {
                return true;
            } else {
                showWarningMessage(t("MessageWrongFileSize1"));
                return false;
            }
        } else {
            showWarningMessage(t("MessageWrongImageFormat"));
            return false;
        }
    }

    const resetImageHandler = () => {
        setBkgImage(null);
        formRef.current.setFieldValue("backgroundImage", null);
    }

    return (
        <>
            <Formik
                enableReinitialize
                initialValues={getInitialValues()}
                onSubmit={submitClickHandler}
                innerRef={formRef}
                validationSchema={validationSchema}
                validate={(values) => {
                    if (onUpdated) onUpdated(item, values);
                }}>
                {(props) => {
                    const {
                        values,
                        setValues
                    } = props;
                    return (
                        <Form noValidate autoComplete="off">
                            <Grid container direction="row" style={{ width: "100%", height: "100%" }}>
                                <Grid item xs={12} style={{ marginBottom: 10 }}>
                                    <Grid container direction="row" justify="space-between">
                                        <Grid item >
                                            <Grid container direction="row" alignItems="center">
                                                <Grid item style={{ marginRight: 20, fontSize: 36 }}>
                                                    <i className={values.icon} />
                                                </Grid>
                                                <Grid item >
                                                    <Grid container direction="row">
                                                        <Grid item xs={12}>
                                                            <Typography variant="caption">
                                                                {values.type ? values.type : "-"}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography variant="h5">
                                                                {values.title ? values.title : "-"}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography variant="caption">
                                                                {values.id ? values.id : "-"}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} style={{ padding: 10 }}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12} >
                                    <Grid container direction="row">
                                        <Grid item xs={12} style={{ padding: 10 }}>
                                            <Grid container spacing={3} style={{ width: "100%" }}>
                                                {!disableIcon &&
                                                    <Grid item xs={12} lg={6} xl={3}>
                                                        <IconPicker
                                                            value={values.icon}
                                                            icons={icons}
                                                            disabled={disabled}
                                                            handleChange={(icon) => {
                                                                setValues({
                                                                    ...values,
                                                                    icon: icon.cssClass,
                                                                    iconCode: icon.code
                                                                }, true);
                                                            }}
                                                            titleText={t("LabelIconPickerText")}>
                                                        </IconPicker>
                                                        <ErrorMessage name="icon" />
                                                    </Grid>
                                                }
                                                {!disableTitle &&
                                                    <Grid item xs={12} lg={6} xl={9}>
                                                        <Field
                                                            className={classes.field}
                                                            name="title"
                                                            type="text"
                                                            variant="outlined"
                                                            label={t("LabelTitle")}
                                                            component={TextField}
                                                            disabled={disabled}
                                                        />
                                                        <FieldError
                                                            name={`[${item.id}].title`}
                                                            errors={errors}
                                                        />
                                                    </Grid>
                                                }
                                                {!disableBackgroundColor &&
                                                    <Grid item xs="auto">
                                                        <Typography>
                                                            {t("LabelBackgroundColor")}
                                                        </Typography>
                                                        <div className={classes.pickerBox}>
                                                            <ColorPicker
                                                                value={values.backgroundColor}
                                                                disabled={disabled}
                                                                className={classes.colorPicker}
                                                                onChange={(x) => {
                                                                    setValues({
                                                                        ...values,
                                                                        backgroundColor: x.hex
                                                                    }, true);
                                                                }}
                                                            />
                                                        </div>
                                                        <FieldError
                                                            name={`[${item.id}].backgroundColor`}
                                                            errors={errors}
                                                        />
                                                    </Grid>
                                                }
                                                {!disableTextColor &&
                                                    <Grid item xs="auto">
                                                        <Typography>
                                                            {t("LabelTextColor")}
                                                        </Typography>
                                                        <div className={classes.pickerBox}>
                                                            <ColorPicker
                                                                value={values.textColor}
                                                                disabled={disabled}
                                                                className={classes.colorPicker}
                                                                onChange={(x) => {
                                                                    setValues({
                                                                        ...values,
                                                                        textColor: x.hex
                                                                    }, true);
                                                                }}
                                                            />
                                                        </div>
                                                        <FieldError
                                                            name={`[${item.id}].textColor`}
                                                            errors={errors}
                                                        />
                                                    </Grid>
                                                }
                                                {!disableIsVisible &&
                                                    <Grid item xs="auto">
                                                        <Field
                                                            type="checkbox"
                                                            name="isVisible"
                                                            component={CheckboxWithLabel}
                                                            Label={{ label: t("LabelVisible") }}
                                                            disabled={disabled}
                                                        />
                                                        <FieldError
                                                            name={`[${item.id}].isVisible`}
                                                            errors={errors}
                                                        />
                                                    </Grid>
                                                }
                                                {
                                                /* 
                                                <Grid item xs="auto">
                                                    <Field
                                                        type="checkbox"
                                                        name="isProtected"
                                                        component={CheckboxWithLabel}
                                                        Label={{ label: t("LabelProtected") }}
                                                        disabled={disabled}
                                                    />
                                                    <FieldError
                                                        name={`[${item.id}].isProtected`}
                                                        errors={errors}
                                                    />
                                                </Grid>
                                                */
                                                }
                                                {!disableIcon &&
                                                    <Grid item xs={12}>
                                                        <Field
                                                            type="checkbox"
                                                            name="hideIcon"
                                                            component={CheckboxWithLabel}
                                                            Label={{ label: t("LabelHideIcon") }}
                                                            disabled={disabled}
                                                        />
                                                        <FieldError
                                                            name={`[${item.id}].hideIcon`}
                                                            errors={errors}
                                                        />
                                                    </Grid>
                                                }
                                                {
                                                   /*
                                                   !disableIcon &&
                                                    <Grid item xs={12}>
                                                        <Field
                                                            type="checkbox"
                                                            name="hideTitle"
                                                            component={CheckboxWithLabel}
                                                            Label={{ label: t("LabelHideTitle") }}
                                                            disabled={disabled}
                                                        />
                                                        <FieldError
                                                            name={`[${item.id}].hideTitle`}
                                                            errors={errors}
                                                        />
                                                    </Grid>
                                                    */
                                                }
                                                {!disableFontSize &&
                                                    <Grid item xs={12}>
                                                        <FormControl variant="outlined" className={classes.formControl}>
                                                            <InputLabel >{t("LabelFontSize")}</InputLabel>
                                                            <Field
                                                                className={classes.field}
                                                                name="fontSize"
                                                                label={t("LabelFontSize")}
                                                                component={Select}
                                                                disabled={disabled}>
                                                                {fontSizeOptions.map(option =>
                                                                    <MenuItem key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </MenuItem>)}
                                                            </Field>
                                                        </FormControl>
                                                        <FieldError
                                                            name={`[${item.id}].fontSize`}
                                                            errors={errors}
                                                        />
                                                    </Grid>
                                                }
                                                {!disableFontStyle &&
                                                    <Grid item xs={12}>
                                                        <FormControl variant="outlined" className={classes.formControl}>
                                                            <InputLabel>{t("LabelFontStyle")}</InputLabel>
                                                            <Field
                                                                className={classes.field}
                                                                name="fontStyle"
                                                                label={t("LabelFontStyle")}
                                                                component={Select}
                                                                disabled={disabled}>
                                                                {fontStyleOptions.map(option =>
                                                                    <MenuItem key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </MenuItem>)}
                                                            </Field>
                                                        </FormControl>
                                                        <FieldError
                                                            name={`[${item.id}].fontStyle`}
                                                            errors={errors}
                                                        />
                                                    </Grid>
                                                }
                                                {!disablePlatform &&
                                                    <Grid item xs={12}>
                                                        <FormControl variant="outlined" className={classes.formControl}>
                                                            <InputLabel >{t("LabelTargetPlatform")}</InputLabel>
                                                            <Field
                                                                className={classes.field}
                                                                name="platform"
                                                                label={t("LabelTargetPlatform")}
                                                                component={Select}
                                                                disabled={disabled}>
                                                                {platformOptions.map(option =>
                                                                    <MenuItem key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </MenuItem>)}
                                                            </Field>
                                                        </FormControl>
                                                        <FieldError
                                                            name={`[${item.id}].platform`}
                                                            errors={errors}
                                                        />
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Grid>
                                        {children &&
                                            <>
                                                <Grid item xs={12} style={{ padding: 10 }}>
                                                    <Divider />
                                                </Grid>
                                                <Grid item xs={12} style={{ padding: 10 }}>
                                                    <Grid container spacing={3} style={{ width: "100%" }}>
                                                        {children}
                                                    </Grid>
                                                </Grid>
                                            </>
                                        }
                                        { /*
                                        <Grid item xs={12} style={{ padding: 10 }}>
                                            <Divider />
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 10 }}>
                                            <Typography>
                                                {t("LabelBackgroundImage")}
                                            </Typography>
                                            <br />

                                            {bkgImage ?
                                                <Button
                                                    className={classes.deleteButton2}
                                                    variant="contained"
                                                    disabled={disabled}
                                                    startIcon={<ClearIcon />}
                                                    onClick={(e) => resetImageHandler()}>
                                                    {t("ButtonRemoveBkgImage")}
                                                </Button>
                                                :
                                                <>
                                                    <UploadFile
                                                        title={t("LabelBackgroundImage")}
                                                        singleFile
                                                        disabled={disabled}
                                                        onFileDrop={(files) => fileDropHandler(files[0])}
                                                        upload={(data, file) => uploadfileAsync(data, file)}
                                                        helpText={t("LabelUploadHelp")}
                                                        uploadButtonText={t("LabelUploadFile")}
                                                        removeButtonText={t("LabelRemoveFile")}
                                                        removeAllButtonText={"LabelRemoveAllFiles"}
                                                    />
                                                </>
                                        </Grid>
                                        */ }
                                        <Grid item xs={12} style={{ padding: 10 }}>
                                            <Divider />
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 10 }}>
                                            <Button
                                                className={classes.deleteButton}
                                                variant="contained"
                                                disabled={disabled}
                                                startIcon={<DeleteIcon />}
                                                onClick={(e) => setOpenDeleteDialog(true)}>
                                                {t("ButtonDelete")}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>)
                }}
            </Formik >
            <Dialog
                open={openDeleteDialog}
                onClose={(e) => setOpenDeleteDialog(false)}>
                <DialogTitle>
                    {t("LabelDeleting")} "{item.title}"
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {t("LabelDeleteConfirmQuestion")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        autoFocus
                        onClick={(e) => setOpenDeleteDialog(false)}
                        color="primary">
                        {t("ButtonCancel")}
                    </Button>
                    <Button onClick={(e) => removeItemHandler()}
                        color="primary"
                        autoFocus>
                        {t("ButtonDelete")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}